//** Not actual IDs */
export enum RecommendationTypeEnum {
  alphastar = 1,
  user = 2,
}